import media from 'style-utils/responsive-utils/media/media';
import styled from 'styled-components';

export const RegistrationStepContainer = styled.div`
  width: 100%;
  padding: 4.2rem 1.6rem 1rem;
  ${media.desktop`
    max-width:calc(100% - 50.1rem;);
    padding:1rem;
  `}
`;
